
    import {Component, Vue, Prop} from 'vue-property-decorator';
    import {dictApi} from '@/api/organization';
    import {instrumentApi} from '@/api/instrument'

    @Component
    export default class UnitData extends Vue {
        title = "单位列表";
        @Prop() private value!: any;
        @Prop() private instrumentId!: any;
        unitData = {}
        // unitData = {
        //     '特殊字符':   [{html:'%',value:'%'}, {html:'%RH',value:'%RH'}, {html:'%V/V',value:'%V/V'}, {html:'′',value:'′'}, {html:'″',value:'″'}, {html:'±',value:'±'}, {html:'Ⅰ',value:'Ⅰ'}, {html:'Ⅱ',value:'Ⅱ'}, {html:'Ⅲ',value:'Ⅲ'}, {html:'Ⅳ',value:'Ⅳ'}, {html:'°',value:'°'}, {html:'Δ',value:'Δ'}	, {html:'θ',value:'θ'}, {html:'λ',value:'λ'}, {html:'τ',value:'τ'}, {html:'τ0',value:'τ0'}, {html:'Φ',value:'Φ'}, {html:'Ω',value:'Ω'}, {html:'⁻¹',value:'⁻¹'}, {html:'⁻²',value:'⁻²'}, {html:'⁻³',value:'⁻³'}, {html:'⁻⁴',value:'⁻⁴'}, {html:'⁻⁵',value:'⁻⁵'}, {html:'⁻⁶',value:'⁻⁶'}, {html:'⁻⁷',value:'⁻⁷'}, {html:'⁻⁸',value:'⁻⁸'}, {html:'⁻⁹',value:'⁻⁹'}],
        //     'A/B/C':      [{html:'A',value:'A'}, {html:'a',value:'a'}, {html:'Bh',value:'Bh'}, {html:'bpm',value:'bpm'}, {html:'Bq',value:'Bq'}, {html:'BSU',value:'BSU'},{html:'℃',value:'℃'}, {html:'cd',value:'cd'}, {html:'cd/cm⁻²',value:'cd/cm⁻²'}, {html:'cGy',value:'cGy'}, {html:'cm',value:'cm'} ,{html:'cm⁻¹',value:'cm⁻¹'}],
        //     'D/F/G':    [{html:'d',value:'d'}, {html:'dB',value:'dB'}, {html:'f',value:'f'}, {html:'FS',value:'FS'}, {html:'g',value:'g'}, {html:'GHz',value:'GHz'}, {html:'Gy',value:'Gy'}, {html:'Gy/min',value:'Gy/min'}, {html:'GΩ',value:'GΩ'}],
        //     'H/J':      [{html:'h',value:'h'}, {html:'HBW',value:'HBW'}, {html:'HLD',value:'HLD'}, {html:'HR',value:'HR'}, {html:'HRA',value:'HRA'}, {html:'HRBW',value:'HRBW'}, {html:'HRC',value:'HRC'}, {html:'HRN',value:'HRN'}, {html:'HRT',value:'HRT'}, {html:'HV',value:'HV'}, {html:'Hz',value:'Hz'}, {html:'J/K',value:'J/K'}],
        //     'K/L':        [{html:'kA',value:'kA'}, {html:'kg',value:'kg'}, {html:'kg/m³',value:'kg/m³'}, {html:'kg/min',value:'kg/min'}, {html:'kHz',value:'kHz'}, {html:'km',value:'km'}, {html:'km/h',value:'km/h'}, {html:'kN',value:'kN'}, {html:'kPa',value:'kPa'}, {html:'kV',value:'kV'}, {html:'kW',value:'kW'}, {html:'kΩ',value:'kΩ'}, {html:'L',value:'L'}, {html:'L/min',value:'L/min'}, {html:'lx',value:'lx'}],
        //     'M':        [{html:'m',value:'m'}, {html:'m/km',value:'m/km'}, {html:'m/s',value:'m/s'}, {html:'m/s⁻²',value:'m/s⁻²'}, {html:'m⁻¹',value:'m⁻¹'}, {html:'m²',value:'m²'}, {html:'m³',value:'m³'}, {html:'m³/h',value:'m³/h'}, {html:'m³/min',value:'m³/min'}, {html:'mA',value:'mA'}, {html:'mg',value:'mg'}, {html:'mg/L',value:'mg/L'}, {html:'MHz',value:'MHz'}, {html:'min',value:'min'}, {html:'mL',value:'mL'} , {html:'mm',value:'mm'}, {html:'mm/m',value:'mm/m'}, {html:'mm²/s',value:'mm²/s'}, {html:'mmHg',value:'mmHg'}, {html:'mmol/L',value:'mmol/L'}, {html:'mol/mol',value:'mol/mol'}, {html:'⁻⁶mol/mol',value:'⁻⁶mol/mol'}, {html:'mOsmol•kg⁻¹',value:'mOsmol•kg⁻¹'}, {html:'MPa',value:'MPa'}, {html:'ms',value:'ms'}, {html:'MV',value:'MV'}, {html:'mV',value:'mV'}, {html:'MW',value:'MW'}, {html:'mW',value:'mW'}, {html:'MΩ',value:'MΩ'}],
        //     'N/P/Q/R/S/T':[{html:'N',value:'N'}, {html:'nC',value:'nC'}, {html:'nD',value:'nD'}, {html:'nF',value:'nF'}, {html:'ng',value:'ng'}, {html:'ng/mL',value:'ng/mL'}, {html:'nm',value:'nm'},{html:'Pa',value:'Pa'}, {html:'Qn',value:'Qn'}, {html:'r',value:'r'}, {html:'r/min',value:'r/min'}, {html:'s',value:'s'}, {html:'t',value:'t'}, {html:'T',value:'T'}, {html:'t/h',value:'t/h'}],
        //     'V/W/Z/μ':    [{html:'V',value:'V'}, {html:'Vp⁻p',value:'Vp⁻p'}, {html:'W',value:'W'}, {html:'W·h',value:'W·h'}, {html:'Z',value:'Z'},{html:'μg',value:'μg'}, {html:'μm',value:'μm'}, {html:'μmol/mol',value:'μmol/mol'}, {html:'μS/cm',value:'μS/cm'}, {html:'μW/cm²',value:'μW/cm²'}],
        // }
        created() {
            if (this.instrumentId) {
                this.getValidSymbols();
            } else {
                this.listUnitList();
            }

        }

        onClick(symbol: any) {
            this.$emit('onChange', JSON.parse(JSON.stringify(symbol)))
        }

        packageData(data: any) {
            let unitData = {} as any;
            data.forEach((d: any) => {
                if (unitData[d.family] == undefined) {
                    unitData[d.family] = [];
                }
                unitData[d.family].push(d);
            });
            return unitData;
        }

        listUnitList() {
            // const unitData = sessionStoragxxe.getItem('all-unit-data') ? JSON.parse(sessionStorage.getItem('all-unit-data') as string) : null;
            // if (unitData != null) {
            //     this.unitData = unitData;
            //     return;
            // }
            dictApi.listDictSymbol({}).then((r: any) => {
                if (r.data.result === 0) {
                    this.unitData = this.packageData(r.data.data);
                    // sessionStorage.setItem("all-unit-data", JSON.stringify(this.unitData))
                }
            });
        }

        getValidSymbols() {
            // const unitData = sessionStorage.getItem('part-unit-data') ? JSON.parse(sessionStorage.getItem('part-unit-data') as string) : null;
            // if (unitData != null) {
            //     this.unitData = unitData;
            //     return;
            // }
            // instrumentApi.getValidSymbols({id: this.instrumentId}).then((r: any) => {
            //     if (r.data.result == 0 && r.data.data.length > 0) {
            //         this.unitData = this.packageData(r.data.data);
                    // sessionStorage.setItem("part-unit-data", JSON.stringify(this.unitData))
                // } else {
                    this.listUnitList();
                // }
            // });
        }
    }
